import 'babel-polyfill';
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import 'vuetify/dist/vuetify.min.css';
import App from './App.vue';
import router from './router';
import store from '@/model/store/store';
import VueMeta from 'vue-meta';
Vue.use(VueMeta);

/** routerが切り替わるたびに呼ばれる処理 **/
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  next();
});

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event('x-app-rendered')),
}).$mount('#app');
